<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="costProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="costProfileId" selectionMode="single"
  [(selection)]="costProfile" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="true" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Cost Profile +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'costProfileId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payTo', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payToUserId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payWhen', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payStatus', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'costAmount', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'costPercent', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-costProfile>
    <tr [pSelectableRow]="costProfile">
      <td>{{costProfile.costProfileId}} </td>
      <td>{{costProfile.shortTermRentalId}}</td>
      <td>{{costProfile.propertyCode}}</td>
      <td>{{costProfile.payTo}}</td>
      <td>{{costProfile.payToUserId}}</td>
      <td>{{getPayWhenName(costProfile)}}</td>
      <td>{{getPayStatusName(costProfile)}}</td>
      <td>{{costProfile.title}}</td>
      <td>{{costProfile.quantity}}</td>
      <td>{{costProfile.costAmount}}</td>
      <td>{{costProfile.costPercent}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(costProfile)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>